/**numberSelect**/
<template>
  <div class="numberSelect">
  </div>
</template>

<script>
  import Picker from 'better-picker'

  export default {
    name: 'xk-numberSelect',
    props: ['data', 'maxNum'],
    computed: {},
    data () {
      return {
        action: 1
      }
    },
    methods: {},
    watch: {},
    mounted: function () {
      let that = this
      let data = that.$props.data
      let obj = []
      for (let i = 0; i < data; i++) {
        obj.push({text: i + 1, value: i + 1})
      }
      let picker = new Picker({
        data: [obj],
        selectedIndex: [0],
        title: that.$props.title
      })
      picker.show()
      picker.on('picker.change', (index, selectedIndex) => {
        that.action = obj[selectedIndex].value
      })
      picker.on('picker.select', (index, selectedIndex) => {
        that.$emit('click', {val: that.action})
        document.getElementsByClassName('picker')[0].remove()
      })
      picker.on('picker.cancel', () => {
        document.getElementsByClassName('picker')[0].remove()
        that.$emit('click')
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
</style>



// WEBPACK FOOTER //
// numberSelect.vue?51a5cabc